import { StandardTermsForServices } from 'src/modules/StandardTermsForServices/StandardTermsForServices';

export default StandardTermsForServices;
